import { AgGridColumnDef } from '@tassat/common-definitions';

import { caseInsensitiveSort } from 'Lib/stringHelpers';

export const ACGNumbersColumnDefs: AgGridColumnDef[] = [
    {
        field: 'ACGNumber',
        headerName: 'ACG Number',
        comparator: (val1, val2) => caseInsensitiveSort(val1, val2),
        menuTabs: ['filterMenuTab'],
        flex: 1
    },
    {
        field: 'ACGName',
        headerName: 'ACG Name',
        comparator: (val1, val2) => caseInsensitiveSort(val1, val2),
        menuTabs: ['filterMenuTab'],
        sort: 'asc',
        flex: 1
    }
];